/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import media from 'css-in-js-media';
import ProductsMegaMenu from './MegaMenus/ProductsMegaMenu';
import CommunityMegaMenu from './MegaMenus/CommunityMegaMenu';
import SolutionsMegaMenu from './MegaMenus/SolutionsMegaMenu';

import Element from '../../element';
import { LazyLink } from '../../../../../../slices/atoms';

export const StyledPrimaryNavLink = styled(Element)`
  color: hsl(221, 93%, 16%);
  background-color: transparent !important;
  font-family: 'WorkSans-Medium', 'Helvetica', 'san-serif';
  font-size: 14px !important;
  padding: 1.35rem 0.75rem;
  margin-right: 15px;

  ${media('<desktop')} {
    font-size: 18px !important;
    border-bottom: 1px solid hsl(218, 18%, 91%);
    margin-bottom: 10px;
    margin-left: 15px;
    margin-right: 15px;
    padding: 5px 0 15px 0;
  }
`;

const navigationTracking = (name, category) => {
  window.analytics.track('Web Interaction', {
    action: 'click',
    category,
    name,
  });
};

const PrimaryNavLinks = navigation => {
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
  const [currentMegaMenu, setCurrentMegaMenu] = useState('');
  const { primary_navigation_links } = navigation;

  const determineMegaMenuActiveState = () => {
    if (typeof window === 'undefined') return;
    const currentPaths = window && window.location && window.location.pathname.split('/').filter(path => path !== '');
    if (currentPaths.length <= 0) return null;
    if (
      (currentPaths && currentPaths[0].toLowerCase() === 'solutions') ||
      (currentPaths && currentPaths[0] === 'business')
    ) {
      return 'solutions';
    }
    if (
      currentPaths &&
      currentPaths[0].toLowerCase() === 'products' &&
      currentPaths &&
      currentPaths[1] !== 'marketplace'
    ) {
      return 'products';
    }
    if (
      (currentPaths && currentPaths[0].toLowerCase() === 'open-source') ||
      (currentPaths && currentPaths[0] === 'hatch')
    ) {
      return 'community';
    }
    return null;
  };

  const openCurrentMegaMenu = megaMenuName => {
    if (isMegaMenuOpen) return setCurrentMegaMenu(megaMenuName);

    setCurrentMegaMenu(megaMenuName);
    setIsMegaMenuOpen(true);
  };

  const closeMegaMenu = () => {
    setIsMegaMenuOpen(false);
    setCurrentMegaMenu('');
  };

  const currentPath = determineMegaMenuActiveState();

  const checkForMegaMenu = item => {
    switch (item.primary_navigation_text) {
      case 'Products': {
        return ProductsMegaMenu(
          item,
          navigation,
          currentPath,
          openCurrentMegaMenu,
          closeMegaMenu,
          isMegaMenuOpen,
          currentMegaMenu,
        );
      }
      case 'Community': {
        return CommunityMegaMenu(
          item,
          navigation,
          currentPath,
          openCurrentMegaMenu,
          closeMegaMenu,
          isMegaMenuOpen,
          currentMegaMenu,
        );
      }
      case 'Solutions': {
        return SolutionsMegaMenu(
          item,
          navigation,
          currentPath,
          openCurrentMegaMenu,
          closeMegaMenu,
          isMegaMenuOpen,
          currentMegaMenu,
        );
      }
      default:
        // NOTE
        return (
          <StyledPrimaryNavLink
            url={item.primary_navigation_link && item.primary_navigation_link.url}
            key={item.primary_navigation_text}
            renderAs={LazyLink}
            activeStyle={{ borderBottom: '2px solid #0069ff', padding: '20px 12px 18px' }}
            onClick={() => {
              navigationTracking(item.primary_tracking_name, item.primary_tracking_category);
            }}
          >
            {item.primary_navigation_text}
          </StyledPrimaryNavLink>
        );
    }
  };

  return primary_navigation_links.map(checkForMegaMenu);
};

export default PrimaryNavLinks;

PrimaryNavLinks.propTypes = {
  navigation: PropTypes.node.isRequired,
};
